import * as MainLayout from './Main'
import * as BaseLayout from './Base'

export const Main = MainLayout.Component
export const Base = BaseLayout.Component
